import React, { useRef } from 'react';
import { Modal } from 'react-bootstrap';
import ReCAPTCHA from 'react-google-recaptcha';

const CaptchaModal = ({ show, onHide, onVerified }) => {
    const recaptchaRef = useRef(null);

    const handleCaptchaChange = (value) => {
        if (value) {
            // Wait 500ms before proceeding to give visual feedback
            setTimeout(() => {
                onVerified(value);
            }, 500);
        }
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            backdrop="static"
            keyboard={false}
            contentClassName="bg-transparent border-0"
        >
            <div
                className="glass-panel p-4 position-relative"
                style={{
                    background: "var(--bg-card)",
                    border: "1px solid var(--glass-border)",
                    borderRadius: "12px",
                    boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.37)",
                    backdropFilter: "blur(12px)",
                }}
            >
                <div className="text-center mb-4">
                    <h3
                        className="h4 fw-bold mb-2"
                        style={{
                            color: "var(--text-main)",
                            fontFamily: "var(--font-heading)",
                            letterSpacing: "1px"
                        }}
                    >
                        Security Check
                    </h3>
                    <p
                        className="mb-0"
                        style={{
                            color: "var(--text-muted)",
                            fontSize: "0.9rem"
                        }}
                    >
                        Please verify you are human to continue.
                    </p>
                </div>

                <div className="d-flex justify-content-center mb-3">
                    <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"} // Fallback to test key if env not set
                        onChange={handleCaptchaChange}
                        theme="dark"
                    />
                </div>

                <div className="text-center">
                    <button
                        onClick={onHide}
                        className="btn btn-link text-decoration-none"
                        style={{
                            color: "var(--text-muted)",
                            fontSize: "0.85rem"
                        }}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default CaptchaModal;
